import { StyleSheet, color } from "../../../../styles/theme";
export var SORT_ARROW_SIZE = 12;
export default StyleSheet.create({
  sortableCell: {
    'display': 'block',
    ':hover': {
      color: color.primaryText
    },
    ':focus': {
      color: color.primaryText
    }
  },
  sortArrow: {
    display: 'inline-flex',
    marginLeft: 10,
    width: SORT_ARROW_SIZE,
    height: SORT_ARROW_SIZE
  }
});